/** Validation des entrées d'authentification (email + mot de passe). */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MIN_PASSWORD_LENGTH = 8;

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email.trim());
}

export interface PasswordCheck {
  valid: boolean;
  reason?: string;
}

export function validatePassword(password: string): PasswordCheck {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return { valid: false, reason: `Le mot de passe doit faire au moins ${MIN_PASSWORD_LENGTH} caractères.` };
  }
  return { valid: true };
}

// URL http(s) basique. Vide = valide (champ optionnel) : à l'appelant d'exiger le non-vide si besoin.
export function isValidUrl(url: string): boolean {
  const trimmed = url.trim();
  if (!trimmed) return true;
  return /^https?:\/\/[^\s.]+\.[^\s]+$/i.test(trimmed);
}
